/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_VinInputs */

const en_case_field_vin = /** @type {(inputs: Case_Field_VinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VIN`)
};

const pt_br2_case_field_vin = /** @type {(inputs: Case_Field_VinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VIN`)
};

/**
* | output |
* | --- |
* | "VIN" |
*
* @param {Case_Field_VinInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_vin = /** @type {((inputs?: Case_Field_VinInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_VinInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_vin(inputs)
	return pt_br2_case_field_vin(inputs)
});